const validateColor = (value) => {
  const HEXColor = value || '';
  const response = { invalid: false, type: '' };
  if (!HEXColor) {
    response.invalid = true;
    response.type = 'empty';
  } else if (HEXColor.length < 4) {
    response.invalid = true;
    response.type = 'invalid';
  } else if (!/^#([0-9A-F]{3}){1,2}$/i.test(HEXColor)) {
    response.invalid = true;
    response.type = 'invalid';
  }
  return response;
};

const validatePaperThickness = (value) => {
  const response = { invalid: false, type: '' };
  if (!`${value}`.trim()) {
    response.invalid = true;
    response.type = 'empty';
  } else if (typeof value === 'number' && value < 0) {
    response.invalid = true;
    response.type = 'negative';
  }
  return response;
};

const generateColorFieldErrorConfig = (value) => {
  const response = { ...validateColor(value), text: '' };
  switch (response.type) {
    case 'empty':
      response.text = 'Field must be filled!';
      break;
    case 'invalid':
      response.text = 'Is invalid HEX format!';
      break;
    default:
      break;
  }
  return {
    error: response.invalid,
    errorMessages: response.invalid ? [response.text] : [],
  };
};

const generatePaperThicknessFieldErrorConfig = (value) => {
  const response = { ...validatePaperThickness(value), text: '' };
  switch (response.type) {
    case 'empty':
      response.text = 'Field must be filled!';
      break;
    case 'negative':
      response.text = 'Value must 0 or more!';
      break;
    default:
      break;
  }
  return {
    error: response.invalid,
    errorMessages: response.invalid ? [response.text] : [],
  };
};

export default {
  validateColor,
  validatePaperThickness,
  generateColorFieldErrorConfig,
  generatePaperThicknessFieldErrorConfig,
};
